module.exports = __webpack_public_path__ + "media/images/icons/invite-adb88d6a5179277e2f5080bdb12b146f.svg";